import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")}/api`
  : "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });

// anonymous visitors legitimately get 401 on /auth/me: keep the console clean
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) error.silent401 = true;
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
